export const configWeight = {
  type: "bar",
  plugins: {
    title: {
      display: true,
      text: "Évolution du poids (sur 2 ans)",
      font: { size: 14 },
      padding: 20,
    },
    legend: {
      position: "bottom",
      labels: { font: { size: 14 } },
    },
    datalabels: {
      align: "top",
      anchor: "end",
      offset: (context) => {
        const value = context.dataset.data[context.dataIndex];
        return value >= 3 ? 10 : -35;
      },
      backgroundColor: "#3D3D3D",
      borderRadius: 4,
      color: "white",
      font: {
        weight: "bold",
      },
      padding: 6,
    },
  },
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      beginAtZero: true,
      suggestedMax: 100,
      suggestedMin: 0,
    },
  },
};

export const dataConfigWeight = (data) => ({
  labels: data.weightLabels,
  datasets: [
    {
      label: "Poids (kg)",
      data: data.weight,
      backgroundColor: "#8CB342",
      datalabels: { display: true },
      borderRadius: {
        topLeft: 6,
        topRight: 6,
        bottomLeft: 0,
        bottomRight: 0,
      },
      borderSkipped: false,
    },
  ],
});
